import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { Image, Nav, Accordion } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";
import logo from "../../../images/logo.svg";
import small_logo from "../../../images/small-logo.png";
import * as Cookies from "es-cookie";
import ContentLoader from 'react-content-loader';
import BrandLogo from "./BrandLogo";


import "./_navbars.scss";

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    width: "3px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

class AsideNavbarDummy extends Component {
  logout = () => {
    if (Cookies.get("studenttoken") !== undefined) {
      Cookies.remove("studenttoken");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentemail");
            Cookies.remove("registermob");

            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("exam_name");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("videos");
            Cookies.remove("branch_name");
            Cookies.remove("role", "");
            Cookies.remove("profile_pic");
            Cookies.remove("student_userlevel");
            Cookies.remove("stulogintype", "");
            localStorage.removeItem('profile_pic');
            localStorage.removeItem('studentglobals');
            localStorage.removeItem('globalsubjects');
            localStorage.removeItem("packageplan");
            if (Cookies.get("institution_id") == 119) {
                window.location.href = "https://vignan.rizee.in/login";
            } else {
                this.props.history.push("/student/login");
            }
    }
    this.props.onClick();
  };
  getAccordianActive = () => {
    switch (this.props.history.location.pathname) {
      // Analysis
      case "/student/result-analysis":
        return 1;
      case "/student/practice-exam-analysis":
        return 1;
      case "/student/strength-analysis":
        return 1;
      case "/student/time-analysis":
        return 1;
      case "/student/complexity-analysis":
        return 1;
      case "/student/error-analysis":
        return 1;
      case "/student/questiontype-analysis":
        return 1;

      default:
        return 0;
    }
  };

  getActiveClassTwo = (link) => {
    if (link === this.props.history.location.pathname)
      return "collapse-item active";
    else return "collapse-item";
  };

  getActiveClass = (link) => {
    if (link === this.props.history.location.pathname) return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/subjects" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/subject/topics" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/pre-exam-test" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/subject/chapter" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/subject/chapter-status" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/subject/practice-exam-history" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/subject/start-watching" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/subject/start-learning" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/subject/short-notes" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/subject/start-error-exam" &&
      link === "/student/learn-practice"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/subject/start-error-exam/error-exam" &&
      link === "/student/learn-practic"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/exams/schedule-exam" &&
      link === "/student/exams"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/exams/adaptive-exam" &&
      link === "/student/exams"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/exams/custom-exam" &&
      link === "/student/exams"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/exams/error-exam" &&
      link === "/student/exams"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/exams/previous-paper-exam" &&
      link === "/student/exams"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/exams/custom-previous-paper-exam" &&
      link === "/student/exams"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/get-ready-for-exam/chapter-exam" &&
      link === "/student/get-ready-for-exam"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/get-ready-for-exam/cumulative-exam" &&
      link === "/student/get-ready-for-exam"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/get-ready-for-exam/semigrand-exam" &&
      link === "/student/get-ready-for-exam"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/get-ready-for-exam/grand-exam" &&
      link === "/student/get-ready-for-exam"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/get-ready-for-exam/get-ready-shortnotes-and-materials" &&
      link === "/student/get-ready-for-exam"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/get-ready-for-exam/get-ready-shortnotes/single-shortnote" &&
      link === "/student/get-ready-for-exam"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/get-ready-for-exam/history" &&
      link === "/student/get-ready-for-exam"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/bookmark/videos" &&
      link === "/student/bookmark"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/bookmark/videos/watch-video" &&
      link === "/student/bookmark"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/bookmark/shortnotes-and-materials" &&
      link === "/student/bookmark"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/bookmark/shortnotes-and-material/single-shortnote" &&
      link === "/student/bookmark"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/bookmark/practice-questions" &&
      link === "/student/bookmark"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/bookmark/exam-questions" &&
      link === "/student/bookmark"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname === "/student/notes/videos" &&
      link === "/student/notes"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/notes/videos/watch-video" &&
      link === "/student/notes"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/notes/shortnotes-and-materials" &&
      link === "/student/notes"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/notes/shortnotes-and-material/single-shortnote" &&
      link === "/student/notes"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/notes/shortnotes-and-material/single-revisions-material" &&
      link === "/student/notes"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/notes/practice-questions" &&
      link === "/student/notes"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/notes/exam-questions" &&
      link === "/student/notes"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/revision-material-groups/custom-revision-materials" &&
      link === "/student/revision-material-groups"
    )
      return "nav-link active";
    else if (
      this.props.history.location.pathname ===
      "/student/revision-material-groups/custom-single-revision-material" &&
      link === "/student/revision-material-groups"
    )
      return "nav-link active";
    else return "nav-link";
  };

  render() {
    return (
      <div id="sidebar" className="sidebar-menu">
        {/* <div className="sidebar-header mt-2 px-3 py-2 text-center">
          <Link
            //to="/student/home" 
            className={this.getActiveClassTwo("/student/home")}>
            <BrandLogo width="159.501" className="logo" fill="#ffffff" />
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97 69" width="40" className="small_logo" style={{ marginLeft: -6 }}>
              <g id="Layer">
                <path fill="#ffffff" d="M0.29 68.12L29.73 17.51L17.03 17.51L27.42 0L51.48 0L88.82 68.13L69.19 68.13L44.55 26.37L20.69 68.13L0.29 68.12Z" />
                <path fill="#f9c52d" d="M56.22 0L96.83 0L76.53 35.5L56.22 0Z" />
              </g>
            </svg>
          </Link>
        </div> */}
        <Scrollbars style={{ height: '90vh' }}
          renderThumbVertical={renderThumb}
          autoHide
          autoHideTimeout={500}
          autoHideDuration={200}>
          <Nav className="navbar-nav menu">
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <hr className="sidebar-divider" />
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <hr className="sidebar-divider" />
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <hr className="sidebar-divider" />
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <Nav.Item>

              <div className="showcase-component">
                <ContentLoader
                  speed={2}
                  width={400}
                  height={50}
                  viewBox="0 0 420 50"
                  backgroundColor="#2f4463"
                  foregroundColor="#ecebeb"
                >
                  <circle cx="40" cy="20" r="10" />
                  <rect x="60" y="15" rx="5" ry="5" width="320" height="15" />
                </ContentLoader>
              </div>
            </Nav.Item>
            <hr className="sidebar-divider" />
          </Nav>
        </Scrollbars>
      </div>

    );
  }
}

export default withRouter(AsideNavbarDummy);
